module.exports = __webpack_public_path__ + "static/EmbedMod-01-c93c4c233f50bd65860554ce0f7b94d1.png";